module.exports = __webpack_public_path__ + "static/media/ic_btm_mail_check.ed67afb8.svg";